import styled from "styled-components";

const Background = styled.div`
  background:${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  height: 100vh;
  width: 100vw;
`;

export default Background;



// WEBPACK FOOTER //
// ./src/components/Background.js